import { camelToSnake } from "utils/camelSnakeTransformation";
import { transformObjectKeys } from "utils/transformObjectKeys";

export class ActionsDto {
  static setupMediaFormData(payload) {
    const formData = new FormData();

    const newPayload = { ...payload, fileName: payload.file?.name };

    const payloadTransformed = transformObjectKeys(newPayload, camelToSnake);

    for (const key in payloadTransformed) {
      if (key === "file") {
        formData.append(key, payloadTransformed[key]);
      } else {
        formData.append(key, payloadTransformed[key]);
      }
    }
    return formData;
  }

  static setupMediaPatchFormData(payload) {
    const formData = new FormData();

    const payloadTransformed = transformObjectKeys(payload, camelToSnake);

    for (const key in payloadTransformed) {
      if (key === "file") {
        formData.append(key, payloadTransformed[key]);
      } else {
        formData.append(key, payloadTransformed[key]);
      }
    }
    return formData;
  }

  static setupMediaResponse(data, fieldId) {
    return {
      id: data.backServiceFileId ?? data.id,
      fieldId: data.fieldId ?? fieldId,
      fileName: data.fileName,
      fileSize: data.fileSize,
      url: data.fileUrl,
      title: data.fileName,
    };
  }
  static setupAllMedia(data) {
    return data.map(this.setupMediaResponse);
  }

  static setupAllAttachments(data) {
    return {
      results: (data.results ?? [])
        .filter((result) => (result.attachments ?? []).length > 0)
        .map((action) => ({
          id: action.id,
          taskId: action.taskId,
          taskName: action.taskName,
          actionTypeId: action.actionTypeId,
          actionTypeName: action.actionTypeName,
          description: action.observationAction?.description,
          createdByUserId: action.createdByUserId,
          attachments: (action.attachments ?? []).map((attachment) => ({
            ...attachment,
          })),
        })),
    };
  }
}
